import Component from './MenuButton'

export default Component
